module.exports = __webpack_public_path__ + "static/media/cleaning_map.ed66f15d.svg";